import Entity from "lib/models/Entity";
import { computed } from "mobx";

interface BlockSource {
  id: string;
  top: number;
  left: number;
  bottom: number;
  right: number;
  isChecked?: boolean;
}

export default class Block extends Entity<BlockSource> {
  @computed
  get left(): number {
    return this.source.left;
  }

  @computed
  get top(): number {
    return this.source.top;
  }

  @computed
  get right(): number {
    return this.source.right;
  }

  @computed
  get bottom(): number {
    return this.source.bottom;
  }

  @computed
  get x(): number {
    return this.source.left;
  }

  @computed
  get y(): number {
    return this.source.top;
  }

  @computed
  get width(): number {
    return this.source.right - this.source.left;
  }

  @computed
  get height(): number {
    return this.source.top - this.source.bottom;
  }

  @computed
  get isChecked(): boolean {
    return this.source.isChecked || false;
  }

  set isChecked(isChecked: boolean) {
    this.source.isChecked = isChecked;
  }
}

export type { BlockSource };
